export default "__VITE_ASSET__5eb4aa71__"